<div class="footer">
    <button mat-button [routerLink]="'faq'">FAQ</button>
    <button mat-button [routerLink]="'downloads'">Downloads</button>
    <a class="btn" mat-button [href]="fanShopUrl" target="_blank">Fanshop</a>
    <button mat-button [routerLink]="'vorstand'">Vorstand</button>
    <button mat-button [routerLink]="'galerie'">Galerie</button>
    <button mat-button [routerLink]="'impressum'">Impressum</button>
    <button mat-button [routerLink]="'datenschutz'">Datenschutz</button>
</div>